"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.School = void 0;
var Base_1 = require("../Base");
var SchoolProfile_1 = require("./SchoolProfile");
var School = /** @class */ (function (_super) {
    __extends(School, _super);
    function School() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    School.getDefaultProfile = function (s) {
        if (s.profiles.length > 0) {
            var defaultProfile = s.profiles.filter(function (profile) { return profile.isDefault; })[0];
            if (!defaultProfile) {
                return s.profiles[0];
            }
            return defaultProfile;
        }
        else {
            return new SchoolProfile_1.SchoolProfile();
        }
    };
    return School;
}(Base_1.BaseModel));
exports.School = School;
//# sourceMappingURL=School.js.map